import './styles/PublicGuard.scss';

import { ErrorBoundary } from '@whistler-ui/k2/components/ErrorBoundary';
import { Loading } from '@whistler-ui/k2/components/Loading';
import { useClassHelper } from '@whistler-ui/k2/hooks/useClassHelper';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

import { useGetCurrentCognitoUser } from '../hooks';
import { useAuthStore } from '../store/auth';
import { routes } from '.';

const componentName = 'c-PublicGuard';

const PublicGuard = () => {
  const navigate = useNavigate();

  const c = useClassHelper(componentName);

  const { setCognitoValues } = useAuthStore();

  const { data: user, isPending } = useGetCurrentCognitoUser({
    silent: true,
  });

  useEffect(() => {
    if (user) {
      setCognitoValues(user);

      // This will navigate to PrivateGuard and make its own validations
      navigate(routes.dashboard.url, {
        replace: true,
      });
    }
  }, [navigate, setCognitoValues, user]);

  if (isPending) {
    return (
      <div className={c('__loading')}>
        <Loading />
      </div>
    );
  }

  if (user === null) {
    return (
      <ErrorBoundary isCentered>
        <Outlet />
      </ErrorBoundary>
    );
  }

  return null;
};

export default PublicGuard;
